/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PetV2FormFieldModel } from './PetV2FormFieldModel';
import {
    PetV2FormFieldModelFromJSON,
    PetV2FormFieldModelFromJSONTyped,
    PetV2FormFieldModelToJSON,
} from './PetV2FormFieldModel';

/**
 * 
 * @export
 * @interface PetV2FormSectionModel
 */
export interface PetV2FormSectionModel {
    /**
     * 
     * @type {string}
     * @memberof PetV2FormSectionModel
     */
    heading: string;
    /**
     * 
     * @type {string}
     * @memberof PetV2FormSectionModel
     */
    subHeading?: string;
    /**
     * 
     * @type {string}
     * @memberof PetV2FormSectionModel
     */
    icon?: PetV2FormSectionModelIconEnum;
    /**
     * this is meant to control the order the section is displayed on the client
     * @type {number}
     * @memberof PetV2FormSectionModel
     */
    order: number;
    /**
     * 
     * @type {Array<PetV2FormFieldModel>}
     * @memberof PetV2FormSectionModel
     */
    formFields: Array<PetV2FormFieldModel>;
}


/**
 * @export
 */
export const PetV2FormSectionModelIconEnum = {
    Award: 'award',
    Close: 'close',
    Expert: 'expert',
    Pharmacy: 'pharmacy',
    Time: 'time',
    Truck: 'truck',
    Birthday: 'birthday',
    Box: 'box',
    ConnectWithAVetDesktop: 'connect-with-a-vet-desktop',
    ConnectWithAVetMobile: 'connect-with-a-vet-mobile',
    Gift: 'gift',
    HeartFill: 'heart-fill',
    HouseClinic: 'house-clinic',
    HouseShelter: 'house-shelter',
    Note: 'note',
    PrescriptionBottle: 'prescription-bottle',
    Storefront: 'storefront',
    Tag: 'tag'
} as const;
export type PetV2FormSectionModelIconEnum = typeof PetV2FormSectionModelIconEnum[keyof typeof PetV2FormSectionModelIconEnum];


/**
 * Check if a given object implements the PetV2FormSectionModel interface.
 */
export function instanceOfPetV2FormSectionModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "heading" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "formFields" in value;

    return isInstance;
}

export function PetV2FormSectionModelFromJSON(json: any): PetV2FormSectionModel {
    return PetV2FormSectionModelFromJSONTyped(json, false);
}

export function PetV2FormSectionModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2FormSectionModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'heading': json['heading'],
        'subHeading': !exists(json, 'subHeading') ? undefined : json['subHeading'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'order': json['order'],
        'formFields': ((json['formFields'] as Array<any>).map(PetV2FormFieldModelFromJSON)),
    };
}

export function PetV2FormSectionModelToJSON(value?: PetV2FormSectionModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'heading': value.heading,
        'subHeading': value.subHeading,
        'icon': value.icon,
        'order': value.order,
        'formFields': ((value.formFields as Array<any>).map(PetV2FormFieldModelToJSON)),
    };
}

